import {Component, OnInit} from '@angular/core';
import {FaqCategory} from '../../model/FaqCategory';
import {FaqCategoryService} from '../../services/faq-category.service';
import {Observable} from 'rxjs';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";
import {CommonModule} from "@angular/common";
import {BadgeComponent} from "../../components/common/badge/badge.component";
import {ColorContrastComponent} from "../../components/admin/color-contrast/color-contrast.component";
import {DynamicModalFormComponent} from "../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import {CategoryFormGeneratorService} from "../../formulaires/admin/category-form-generator.service";
import {DynamicTableComponent} from "../../components/common/dynamic-table/dynamic-table.component";

@Component({
    selector: 'app-faq-categories',
    templateUrl: './faq-categories.component.html',
    imports: [
        CommonModule,
        AdminPageModelComponent,
        DynamicModalFormComponent,
        BadgeComponent,
        ColorContrastComponent,
        DynamicTableComponent
    ],
    styleUrls: ['./faq-categories.component.css']
})
export class FaqCategoriesComponent implements OnInit {

  url: string;
  categories: Observable<FaqCategory[]>;
  toEdit: FaqCategory;

  tableActions = [
    {
      icon: 'pen',
      eventHandler: (item) =>  this.toEdit = Object.assign({}, item),
      cssClass: 'text-info',
      tooltip: 'Modifier'
    }
  ];

  // Table headers and sorting ['Aperçu', 'Nom', 'Couleur de fond', 'Couleur de texte', 'Accessibilité']
  tableaHeaders = [
    { label: "Aperçu" },
    {
      label: "Nom",
      sortable: true,
      property: 'name',
    },
    { label: 'Couleur de fond' },
    { label: 'Couleur de texte' },
    { label: 'Accessibilité' }
  ]

  constructor(
    private faqCategoryService: FaqCategoryService,
    private http: HttpClient,
    public categoryFormGeneratorService: CategoryFormGeneratorService) {
  }

  ngOnInit(): void {
    this.http.get(`${environment.backend}/faq/url`).subscribe((v: { url: string }) => {
      this.url = v.url;
    });

    this.categories = this.faqCategoryService.getObjects();
  }

  saveCategory(cat: FaqCategory): void {
    // '...' is to merge objects !
    this.faqCategoryService.createObject({...this.toEdit, ...cat});
  }

  mergeToEdited(form: any) {
    return {...this.toEdit, ...form.getRawValue()};
  }
}
